import React from "react";
import { MDBBtn, MDBCard, MDBCardBody } from "mdb-react-ui-kit";

export const ConfirmRorCard = ({ task, onConfirmRor }) => {
  const location = [task.data?.city, task.data?.country].filter(Boolean).join(", ");

  return (
    <MDBCard className="mb-3 text-start">
      <MDBCardBody className="p-3">
        <div
          className="form-control py-2"
          style={{
            height: "auto",
            minHeight: "unset",
            fontSize: "1rem",
            lineHeight: 1.35,
          }}
        >
          {task.data?.affiliation}
        </div>
        {task.data?.address && (
          <div className="text-muted mt-1" style={{ fontSize: "0.875rem" }}>
            <span className="fw-bold">Address:</span> {task.data.address}
          </div>
        )}
        <div className="d-flex align-items-center gap-2 border-start border-3 border-primary ps-2 py-2 mt-2">
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <div className="fw-semibold" style={{ fontSize: "1rem", lineHeight: 1.3 }}>
              {task.data?.ror_name}
              {location && (
                <span className="fw-normal text-muted">{`, ${location}`}</span>
              )}
            </div>
            <a
              href={task.data?.ror_id}
              target="_blank"
              rel="noreferrer"
              aria-label={`Link to ${task.data?.ror_name}`}
              className="text-decoration-none d-inline-block text-truncate w-100"
              style={{ fontSize: "0.875rem", lineHeight: 1.3 }}
            >
              {task.data?.ror_id}
            </a>
          </div>
        </div>
        <div className="d-flex flex-wrap gap-2 mt-2">
          <MDBBtn size="sm" color="success" onClick={() => onConfirmRor(true)}>
            Confirm
          </MDBBtn>
          <MDBBtn size="sm" color="danger" onClick={() => onConfirmRor(false)}>
            False positive
          </MDBBtn>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};
